import { Helmet } from 'react-helmet';

function Guide() {
  const title = 'Guide';

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div class="container mt-2 mb-5 py-sm-7">
        <div class="row">
            <div class="col-12">
                <h3>AccessEVA User Guide</h3>
                <h5>Sign Up/Login</h5>
                <ol>
                    <li>From the landing page, click “Sign Up” or “Login” in the upper right.</li>
                    <li>On the “Disclaimer” page, read and accept the Disclaimer, Terms of Service, and Privacy Policy, then click “Next.”</li>
                    <li>Follow the prompts to complete user authentication.</li>
                </ol>
                <h5>Projects Directory</h5>
                <ol>
                    <li>Read Helpful Hints.</li>
                    <li>To create a new project:
                        <ul>
                            <li>Click “Create New Project.”</li>
                            <li>Enter the project name and description, then click “Save Changes.”</li>
                            <li>You'll return to the “Projects Directory.”</li>
                        </ul>
                    </li>
                    <li>For a project:
                        <ul>
                            <li>Click “Options” to either:
                                <ul>
                                    <li>Select previously vectored files from the “Resources Directory.”</li>
                                    <li>Upload and vector new files from your computer.</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>Once a project has the desired vectored files:
                        <ul>
                            <li>Click on the project name to access its page.</li>
                        </ul>
                    </li>
                    <li>To search for a project:
                        <ul>
                            <li>Scroll through the list or use the “Project Name Search.”</li>
                        </ul>
                    </li>
                </ol>
                <h5>Project Screen</h5>
                <ol>
                    <li>Queries and Responses:
                        <ul>
                            <li>Type your query in the “Type a Query…” box and click “Query.”</li>
                            <li>To refine responses, continue typing queries as needed.</li>
                            <li>Queries and responses will appear in the window and log under “History.”</li>
                            <li>To start a new query, click “New Query.”</li>
                        </ul>
                    </li>
                    <li>History – Queries and Responses:
                        <ul>
                            <li>Select past queries and responses from the list.</li>
                            <li>To view files used for queries, click “Files Used for Queries.”</li>
                            <li>Attach new files from your computer or the “Resources Directory.”</li>
                        </ul>
                    </li>
                </ol>
                <h5>Resources Directory</h5>
                <ol>
                    <li>Read Helpful Hints.</li>
                    <li>To add files to the directory:
                        <ul>
                            <li>Click “Add Files to Resources” and follow the prompts.</li>
                        </ul>
                    </li>
                    <li>To create a new project with files from the directory:
                        <ul>
                            <li>Click “Create New Project” and follow the prompts.</li>
                        </ul>
                    </li>
                    <li>To search for files:
                        <ul>
                            <li>Scroll or use “File Name Search.”</li>
                        </ul>
                    </li>
                    <li>Rename or delete files using the associated buttons.</li>
                </ol>
                <h5>Feedback</h5>
                <p>At any time, click “Feedback” in the upper right to provide comments or suggestions.</p>
            </div>
        </div>
    </div>


    </>
  );
}

export default Guide;
